import {
    LOAD_TOWCOMPANYTRUCK_DATA,
    DELETE_A_TOWCOMPANYTRUCK,
    SAVE_A_TOWCOMPANYTRUCK,
    UPDATE_A_TOWCOMPANYTRUCK,
    CLEAR_A_TOWCOMPANYTRUCK_ERROR_MESSAGE
} from './actions';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE} from "../towjob/actions";

const initialState = {
  towcompanytrucksArray:[],
    deleteTowCompanyTruckResp:{},
    errorCMsg:{},
    saveTowCompanyTruckResp:{},
    updateTowCompanyTruckResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_TOWCOMPANYTRUCK_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_TOWCOMPANYTRUCK_DATA:
          return Object.assign({}, state, {
              towcompanytrucksArray: action.towcompanytrucksData
          });
          case DELETE_A_TOWCOMPANYTRUCK:
          return Object.assign({}, state, {
              deleteTowCompanyTruckResp: action.deleteTowCompanyTruckResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_TOWCOMPANYTRUCK:
          return Object.assign({}, state, {
              saveTowCompanyTruckResp: action.saveTowCompanyTruckResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_TOWCOMPANYTRUCK:
          return Object.assign({}, state, {
              updateTowCompanyTruckResp: action.updateTowCompanyTruckResponse,
              errorCMsg: action.errorMsg
          });

    default:
      return state;
  }
}
